export const isValidNumber = (num) => ((typeof num === 'number') && !Number.isNaN(num));
export const isValidFunc = (func) => (typeof func === 'function');
export const isValidArrayLength = (arr) => ((Array.isArray(arr) && !!arr.length));
export const isValidObject = (obj) => (!Array.isArray(obj) && (typeof obj === 'object') && !!obj);
export const isValidString = (str) => ((typeof str === 'string') && (!!str.length));
